import { useState } from 'react';

const FAQS = [
  {
    q: 'Who provides roofing services near me?',
    a: 'All Done Roofing LLC provides professional roofing services throughout Gulfport, Biloxi, Ocean Springs, Long Beach, and the Mississippi Gulf Coast. We handle residential and commercial properties — from inspections to full replacements — built for local coastal conditions.',
  },
  {
    q: 'How much does a new roof cost in Mississippi?',
    a: 'Roofing costs depend on the size of your home, the materials chosen, and the condition of your current roof. We provide thorough on-site inspections and fully transparent estimates — no surprise charges, no vague line items — before any work begins.',
  },
  {
    q: 'How long does a roof replacement take?',
    a: 'Most residential roof replacements are completed within one to three days, depending on the size and complexity of the project. We provide a clear timeline upfront and keep you informed throughout the entire process from start to finish.',
  },
  {
    q: 'Do I need a roof repair or a full replacement?',
    a: 'We assess your roof\'s condition and recommend the most cost-effective solution based on the extent of damage, the age of the roof, and long-term performance. Persistent leaks, missing shingles, sagging, or storm damage often indicate that replacement is the smarter investment.',
  },
  {
    q: 'Can you help with my insurance claim?',
    a: 'Absolutely. We specialize in insurance claim assistance — working directly with your adjuster, documenting all storm and wind damage thoroughly, and advocating on your behalf to ensure you receive the full coverage your property deserves.',
  },
  {
    q: 'Are you licensed and insured in Mississippi?',
    a: 'Yes. All Done Roofing LLC is fully licensed and insured in Mississippi, GAF Certified, and Fortification Certified — meeting all state and industry requirements. Every project is backed by our workmanship warranty.',
  },
  {
    q: 'What roofing materials do you use?',
    a: 'We use premium GAF asphalt shingles, metal roofing systems, and commercial flat roofing materials including TPO and modified bitumen. All materials are high-grade, selected to match your needs, budget, and the demands of the Gulf Coast climate.',
  },
  {
    q: 'Do you offer free roofing estimates?',
    a: 'Yes — all inspections and estimates are completely free with no obligation. We assess your roof, walk you through our findings, and provide a detailed written estimate. No pressure. No upsells. Just honest answers.',
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section id="faq" className="py-24 md:py-32 bg-cream">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="mb-14">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-8 h-px bg-gold"></span>
            <span className="text-[11px] font-bold tracking-super uppercase text-gold">FAQ</span>
          </div>
          <h2 className="font-condensed font-bold text-5xl md:text-6xl text-charcoal uppercase leading-none mb-3">
            Frequently Asked<br />
            <span className="font-serif font-normal italic text-gray-400 text-4xl md:text-5xl normal-case leading-tight">Questions</span>
          </h2>
          <p className="text-gray-500 text-sm font-light mt-4 max-w-lg">Honest answers to the most common questions about our roofing services, process, and certifications.</p>
        </div>

        {/* Accordion */}
        <div className="flex flex-col gap-2">
          {FAQS.map((f, i) => (
            <div key={i}
              className={`border rounded-lg overflow-hidden transition-all duration-200 ${open === i ? 'border-gold/40 bg-white' : 'border-gray-200 bg-white/60 hover:border-gray-300'}`}>
              <button onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-start justify-between gap-6 px-6 py-5 text-left cursor-pointer group">
                <span className={`font-semibold text-sm leading-snug transition-colors ${open === i ? 'text-charcoal' : 'text-gray-700 group-hover:text-charcoal'}`}>
                  {f.q}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center shrink-0 rounded transition-all mt-0.5 ${open === i ? 'bg-gold/15' : 'bg-gray-100 group-hover:bg-gray-200'}`}>
                  <i className={`text-xs transition-transform duration-300 ${open === i ? 'ri-subtract-line text-gold' : 'ri-add-line text-gray-500'}`}></i>
                </div>
              </button>
              <div className={`transition-all duration-300 overflow-hidden ${open === i ? 'max-h-60' : 'max-h-0'}`}>
                <div className="px-6 pb-5 border-t border-gray-100 pt-4">
                  <p className="text-gray-500 text-sm leading-relaxed font-light">{f.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Still have questions */}
        <div className="mt-10 pt-8 border-t border-gray-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <p className="font-semibold text-charcoal text-sm mb-1">Still have questions?</p>
            <p className="text-gray-400 text-sm font-light">We&apos;re happy to walk you through everything — no obligation.</p>
          </div>
          <a href="tel:2285473887"
            className="inline-flex items-center gap-3 bg-gold text-ink font-bold text-[12px] tracking-widest uppercase px-7 py-3.5 rounded hover:bg-gold-light transition-colors cursor-pointer whitespace-nowrap">
            <i className="ri-phone-fill"></i>
            Call (228) 547-3887
          </a>
        </div>
      </div>
    </section>
  );
}
